import { Accordion } from 'react-bootstrap'
import { useState } from 'react'
import { useEffect } from 'react'

const MyAccordionItem = ({ 
    icon,
    name,
    eventKey = 0,
    description,
    childs = [],
}) => { 
    const [show, setShow] = useState(false)

    return (
        <>
            <Accordion.Item
                key={eventKey}
                eventKey={eventKey}
                className='mb-2'
            >
                <Accordion.Header onClick={() => setShow(!show)}>
                    <div className='d-flex justify-content-left align-items-center w-90'>
                        <div className='d-flex justify-content-left align-items-center w-90'>
                            <img src={icon ?? ''} alt="icon" />
                            <span className='ml-1'>{name ?? 'Sin Nombre'}</span>
                        </div>
                    </div>
                    <i className={'fas ' + (show ? 'fa-chevron-up' : 'fa-chevron-down')}></i>
                </Accordion.Header>
                <Accordion.Body>
                    <div className="row">
                        <div className="col-12 pl-3 pr-3 pb-2">
                            {description}
                        </div>
                    </div>
                    {childs.length > 0 && (
                        <Accordion className='ml-3'>
                            { childs }
                        </Accordion>
                    )}
                </Accordion.Body>
            </Accordion.Item>
        </>
    )
}

export default MyAccordionItem